<template>
  <div no-body class="mb-1 py-1 bg-white">
    <div header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="collapsibleId"
            block
            class="d-flex collapseHeadStyle"
            @click="isVisibleCriminalRecords = !isVisibleCriminalRecords"
          >
            <p class="mb-0 text-dark font-weight-bold">
              Criminal Records ({{ criminalData.length }})
            </p>
            <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isVisibleCriminalRecords ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="collapsibleId" visible>
              <div v-if="criminalError === null">
                <b-row v-if="criminalData.length">
                  <b-col v-for="(data, index) in criminalData"
          :key="index"
          cols="12"
          class="mt-1 baseContentFont">
          <div class="px-3 m-1 border">
          <div >
            <b-row class="my-2">
                    <b-col md="9"
                ><div
                  ><b>Name: </b
                  >{{ data.name }}</div
                ><div
                  ><b>Offender ID: </b
                  >{{ data.offenderID }}</div
                ></b-col
              >
              <b-col
                ><div
                  ><b>SSN: </b
                  >{{ formatSSN(data.ssn) }}

                  </div
                ><div
                  ><b>DOB: </b
                  >{{ data.dob }}   </div
                ></b-col
              >
                  </b-row>
                </div>

                <div class="mt-2">
                <div class="border px-3 py-1 mb-3">
            <b-row>
                <b-col><b>Case Number: </b>{{ data.caseNumber }}</b-col>
                <b-col> <b>Case Filing Date: </b>{{ data.caseFilingDate }}</b-col>
                <b-col><b>Status: </b>{{ data.status }}</b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col><b>Document Number:
                  </b>{{ data.documentNumber }}</b-col>
                  </b-row>
                </div>
                </div>


                <!-- Criminal Offense Details -->
                <div v-if="data.criminalOffenseDtls && data.criminalOffenseDtls.length">
                <div v-for="(offense, offenseindex) in data.criminalOffenseDtls" :key="offenseindex"  class="mt-2">
              <BaseELabel v-if="offense.offenseDate !== null && offense.offenseDate !== ''" :label="`Offense Details (${offense.offenseDate}) - Record ${offenseindex + 1}`" class="mb-2" new-style />

              <BaseELabel v-else :label="`Offense Details - Record ${offenseindex + 1}`" class="mb-2" new-style />
              <div class="border px-3 py-1 mb-3">
                <div class="border-bottom pb-2">
                  <b-row>
                  <b-col><b>Case Number: </b>{{ formatData(offense.caseNumber) }}</b-col>
                  <b-col> <b>Case Type: </b>{{ formatData(offense.caseType) }}</b-col>
                  <b-col><b>Offense Type: </b>{{ formatData(offense.offenseType) }}</b-col>
                  </b-row>

                  <b-row>
                  <b-col><b>Sentence Date: </b>{{ formatData(offense.sentenceDate) }}</b-col>
                  <b-col> <b>Sentence: </b>{{ formatData(offense.sentence) }}</b-col>
                  <b-col><b>County: </b>{{ formatData(offense.county) }}</b-col>
                  </b-row>

                  <b-row>
                  <b-col><b>Incarceration Date: </b>{{ formatData(offense.incarcerationDate) }}</b-col>
                  <b-col> <b>Offense Count: </b>{{ formatData(offense.offenseCount) }}</b-col>
                  <b-col><b>Case Description: </b>{{ formatData(offense.caseDescription) }}</b-col>
                  </b-row >
              </div>

              <div class="border-bottom pb-2 mt-2">
                  <b-row>
                  <b-col><b>Arrest Case Number: </b>{{ formatData(offense.arrestCaseNumber) }}</b-col>
                  <b-col> <b>Arrest Date: </b>{{ formatData(offense.arrestDate) }}</b-col>
                  <b-col><b>Agency: </b>{{ formatData(offense.arrestAgency) }}</b-col>
                  </b-row>

                  <b-row>
                  <b-col><b>Level: </b>{{ formatData(offense.arrestLevel) }}</b-col>
                  <b-col> <b>Statute: </b>{{ formatData(offense.arrestStatute) }}</b-col>
                  <b-col><b>Offense: </b>{{ formatData(offense.arrestOffense) }}</b-col>
                  </b-row>

                  <b-row>
                  <b-col><b>Disposition Date: </b>{{ formatData(offense.arrestDispositionDate) }}</b-col>
                  <b-col> <b>Disposition: </b>{{ formatData(offense.arrestDisposition) }}</b-col>
                  <b-col></b-col>
                  </b-row >
              </div>

              <div class="pb-2 mt-2">
                  <b-row>
                  <b-col><b>Court Case Number: </b>{{ formatData(offense.courtCaseNumber) }}</b-col>
                  <b-col> <b>Description: </b>{{ formatData(offense.courtDescription) }}</b-col>
                  <b-col><b>Disposition: </b>{{ formatData(offense.courtDisposition) }}</b-col>
                  </b-row>

                  <b-row>
                  <b-col><b>Level: </b>{{ formatData(offense.courtLevel) }}</b-col>
                  <b-col> <b>Statute: </b>{{ formatData(offense.courtStatute) }}</b-col>
                  <b-col><b>Plea: </b>{{ formatData(offense.courtPlea) }}</b-col>
                  </b-row>

                  <b-row>
                    <b-col><b>Fine: </b>{{ formatData(offense.courtFine) }}</b-col>
                  <b-col><b>Jail: </b>{{ formatData(offense.courtJail) }}</b-col>
                  <b-col> <b>Probation: </b>{{ formatData(offense.courtProbation) }}</b-col>

                  </b-row>

                  <b-row>
                    <b-col><b>Suspended: </b>{{ formatData(offense.courtSuspended) }}</b-col>
                    <b-col><b>Suspended Fine: </b>{{ formatData(offense.courtSuspendedFine) }}</b-col>
                    <b-col><b>Offense: </b>{{ formatData(offense.courtOffense) }}</b-col>
                  </b-row >
              </div>

              </div>
              </div>
            </div>
            <div v-else>
              <BaseELabel :label="`Offense Details`" />
                          <NoRecordFound  class="mb-2" />
            </div>

            <div v-if="data.criminalPrisonSentnce && data.criminalPrisonSentnce.length">
              <div v-for="(prison, prisonindex) in data.criminalPrisonSentnce" :key="prisonindex"  class="mt-2">
                <BaseELabel v-if="prison.prisonAdmittedDate !== null && prison.prisonAdmittedDate !== ''" :label="`Prison Details (${prison.prisonAdmittedDate}) - Record ${prisonindex + 1}`" class="mb-2" new-style />
                <BaseELabel v-else :label="`Prison Details - Record ${prisonindex + 1}`" class="mb-2" new-style />
                <div class="border px-3 py-1 mb-3">
                  <div class="pb-2">
                    <b-row>
                    <b-col><b>Scheduled Release Date: </b>{{ formatData(prison.prisonScheduledReleaseDate) }}</b-col>
                    <b-col> <b>Status: </b>{{ formatData(prison.prisonStatus) }}</b-col>
                    <b-col><b>Location: </b>{{ formatData(prison.prisonLocation) }}</b-col>
                    </b-row>

                    <b-row>
                    <b-col><b>Custody Type: </b>{{ formatData(prison.prisonCustodyType) }}</b-col>
                    <b-col> </b-col>
                    <b-col></b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
              <div v-else>
                <BaseELabel class="mb-2" :label="`Prison Details`" new-style />
                          <NoRecordFound  class="mb-2" />
            </div>

            <div v-if="data.criminalParoleSentnce && data.criminalParoleSentnce.length">
              <div v-for="(parole, paroleindex) in data.criminalParoleSentnce" :key="paroleindex"  class="mt-2">
                <BaseELabel v-if="parole.paroleDateReported !== null && parole.paroleDateReported !== ''" :label="`Parole Details (${parole.paroleDateReported}) - Record ${paroleindex + 1}`" class="mb-2" new-style />
                <BaseELabel v-else :label="`Parole Details - Record ${paroleindex + 1}`" class="mb-2" new-style />
                <div class="border px-3 py-1 mb-3">
                  <div class="pb-2">
                    <b-row>
                    <b-col><b>Start Date: </b>{{ formatData(parole.startDate) }}</b-col>
                    <b-col> <b>Status/Length: </b>{{ statusParole(parole) }}</b-col>
                    <b-col><b>County: </b>{{ formatData(parole.paroleCounty) }}</b-col>
                    </b-row>

                    <b-row>
                    <b-col><b>Scheduled End Date: </b>{{ formatData(parole.scheduledEndDate) }}</b-col>
                    <b-col> <b>Actual End Date: </b>{{ formatData(parole.actualEndDate) }}</b-col>
                    <b-col><b>3G Offender: </b>{{ formatData(parole.threeGOffender) }}</b-col>
                    </b-row>

                    <b-row>
                    <b-col><b>Sex Offender: </b>{{ formatData(parole.sexOffender) }}</b-col>
                    <b-col> <b>Violent Offender: </b>{{ formatData(parole.violentOffender) }}</b-col>
                    <b-col><b>Violent Offender Program: </b>{{ formatData(parole.violentOffenderProgram) }}</b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
                <BaseELabel :label="`Parole Details`" class="mb-2" new-style />
                          <NoRecordFound  class="mb-2" />
            </div>

            <div v-if="data.criminalRecordAKA && data.criminalRecordAKA.length">
              <div class="mt-2">
                <BaseELabel :label="`AKAs:`" class="mb-2" new-style />
                <div class="px-3 py-1 mb-3">
                  <div class="pb-2">
                    <b-row >
                    <b-col v-for="(aka, akaindex) in data.criminalRecordAKA" :key="akaindex" class="border col-6"> {{ aka.name }}
                      </b-col>
                      </b-row>
                    </div>
                    </div>
                    </div>
                  </div>

                  <div v-else>
                <BaseELabel :label="`AKAs`" class="mb-2" new-style />
                          <NoRecordFound  class="mb-2" />
            </div>
          </div>
                  </b-col>
                </b-row>
                <NoRecordFound v-else  class="mx-1" />
              </div>
              <CustomMessage v-else :custom-msg="criminalError"/>
              </b-collapse>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
import CustomMessage from '@/src/components/_custom-message.vue'


export default {
  components: {
    NoRecordFound,
    CustomMessage
  },
  props: {
    criminalData: {
      type: Array,
      default: () => [],
    },
    collapsibleId: {
      type:String,
      default: ""
    },
    criminalError: {
      type:String,
      default: null
    },
  },
  data() {
    return {
      isVisibleCriminalRecords: false
    }
  },
  computed: {
    },
  methods: {
    formatData(value) {
      return value || null
    },
    formatSSN(value) {
      return value ? value.trim() ? 'XXX-XX-'+ value.substring(7) : '' : ''
},
statusParole (obj) {
      if ((obj.paroleStatus && obj.paroleStatus !== '') && (obj.length && obj.length !== '')) {
        return `${obj.paroleStatus}/${obj.length}`
      }
      else if (obj.paroleStatus && obj.paroleStatus !== '') {
        return obj.paroleStatus }
        else return obj.length
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
.collapseHeadStyle {
  background-color: $color-raisin-40 !important;
  border: none;
}
</style>
